// Generated by ReScript, PLEASE EDIT WITH CARE


function makeClientAssetPreloader(preparedAssetsMap) {
  return function (param, asset) {
    var assetIdentifier;
    switch (asset.TAG) {
      case "Component" :
          assetIdentifier = "component:" + asset._0.__$rescriptChunkName__;
          break;
      case "Image" :
          assetIdentifier = "image:" + asset.url;
          break;
      case "Style" :
          assetIdentifier = "style:" + asset.url;
          break;
      
    }
    var match = preparedAssetsMap[assetIdentifier];
    if (match !== undefined) {
      return ;
    }
    preparedAssetsMap[assetIdentifier] = true;
    switch (asset.TAG) {
      case "Component" :
          return asset._0.load();
      case "Image" :
      case "Style" :
          return ;
      
    }
  };
}

export {
  makeClientAssetPreloader ,
}
/* No side effect */
